<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider
      v-model="collapsed"
      :trigger="null"
      :hasSider="false"
      :width="230"
      :collapsedWidth="65"
      @mouseenter="toggleCollapse"
      @mouseleave="toggleCollapsefalse"
      class="layout-sider"
    >
      <router-link to="/mainhome">
        <div class="logo">
          <img src="../../static/img/logo.svg" width="31vh" class="title-img" />
          <span class="titles" v-if="tax_display">首页</span>
        </div>
      </router-link>
      <!--         -->
      <a-menu v-model="selectedKeys" theme="light" mode="inline" ref="amenuRef" @select="fun">
        <template v-for="v in routeDetails">
          <a-menu-item :key="v.path" :title="false">
            <template v-if="typeof v.icon === 'object'">
              <a-icon :component="v.icon" />
            </template>
            <template v-else>
              <a-icon type="user" />
            </template>
            <span>{{ v.name }}</span>
            <router-link :to="v.path" />
          </a-menu-item>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-content :style="{ margin: '0px 4px 0px 70px', background: '#F6F6F6' }">
        <a-layout-content :style="{ minHeight: minHeight, margin: '0px 5px 0px 4px' }">
          <slot></slot>
        </a-layout-content>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import SiderMenu from '@/components/menu/SiderMenu'
const minHeight = window.innerHeight - 164 - 24
export default {
  name: 'GlobalLayout',
  components: {
    SiderMenu,
  },
  data() {
    return {
      minHeight: minHeight + 'px',
      collapsed: true,
      showSetting: false,
      tax_display: false,
      routeDetails: [],
      selectedKeys: [],
    }
  },
  created() {
    this.$router.options.routes[2].children.forEach(element => {
      if (element.invisible == false) {
        this.recursion(element)
      }
    })
  },
  mounted() {
    this.initSelectKeys()
  },
  computed: {
    isMobile() {
      return this.$store.state.setting.isMobile
    },
    theme() {
      return 'light'
      // return this.$store.state.setting.theme
    },
    layout() {
      return this.$store.state.setting.layout
    },
    linkList() {
      return this.$store.state.setting.footerLinks
    },
    copyright() {
      return this.$store.state.setting.copyright
    },
  },
  watch: {
    $route: function () {
      this.collapsed = true
      this.tax_display = false
      this.initSelectKeys()
    },
  },
  methods: {
    initSelectKeys(path) {
      if (path) {
        this.selectedKeys = [path]
      } else {
        this.selectedKeys = [this.$route.path]
      }
      console.log(' this.selectedKeys', this.selectedKeys)
    },
    fun(e) {
      console.log('fun', e)
      this.initSelectKeys(e.keyPath)
    },
    toggleCollapse() {
      this.collapsed = false
      this.tax_display = true
    },
    toggleCollapsefalse() {
      this.collapsed = true
      this.tax_display = false
    },
    onSettingDrawerChange(val) {
      this.showSetting = val
    },
    recursion(e) {
      console.log('recursion', e.children)
      e.children.forEach((v, i) => {
        if (v.children) {
          this.recursion(v)
        } else {
          if (!(v.invisible || v.invisible == true)) {
            this.routeDetails.push(v)
          }
        }
      })
      console.log('routeDetails', this.routeDetails)
    },
  },
}
</script>
<style scoped>
.titles {
  width: 50px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  position: relative;
  top: 9px;
  right: -16px;
}
.title-img {
  margin: 14px -8px 4px 19px;
}
.ant-menu-inline-collapsed {
  width: 65%;
  border: none;
}
.ant-menu-inline-collapsed > .ant-menu-item .anticon {
  margin: -10px;
  font-size: 20px;
}
.ant-menu-item .anticon {
  font-size: 20px;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
#components-layout-demo-custom-trigger .logo {
  height: 64px;
  background: #e93434;
  cursor: pointer;
}
.ant-layout-sider {
  background-color: white;
}
.layout-sider {
  height: 100%;
  position: absolute;
  z-index: 10;
  box-shadow: 0px 0px 4px 0.5px LightGrey;
}
</style>



// WEBPACK FOOTER //
// src/layouts/GlobalLayout.vue